<template>
    <v-card outlined rounded="lg" v-bind="{ loading }" style="overflow: initial">
        <v-row class="ma-0 pa-10" align="center">
            <v-col cols="auto" class="page-text--lg">
                <v-avatar color="grey darken-1" size="30" class="mr-10 mr-md-20">
                    <v-img :src="profileSrc">
                        <v-fade-transition>
                            <v-icon v-show="!profileSrc" color="white">mdi-account</v-icon>
                        </v-fade-transition>
                    </v-img>
                </v-avatar>
                {{ application?.resume?.personalInformation?.name }}
                <span class="font-size-14 font-weight-regular grey-9--text"> ({{ application?.resume?.personalInformation?.genderText }}, {{ application?.resume?.personalInformation?.age }}) </span>
            </v-col>
            <v-col>
                <v-row v-for="text in infoItems" :key="text" no-gutters class="grey-6--text">
                    <v-col cols="auto"> <v-icon small color="grey lighten-1">mdi-circle-small</v-icon> </v-col> <v-col>{{ text }}</v-col>
                </v-row>
            </v-col>
            <v-col cols="auto">
                <v-sheet width="220">
                    <v-select :value="schedule.date" :items="scheduleDateItems" :class="`meeting-status-item-date-${className}`" :menuProps="{ attach: `.meeting-status-item-date-${className}` }" v-bind="{ ...attrs_input, loading }" @change="(date) => save({ date })" />
                </v-sheet>
            </v-col>
            <v-col cols="auto" class="d-flex flex-column">
                <v-sheet width="220">
                    <v-select :value="schedule.state" :items="scheduleStates" :class="`meeting-status-item-state-${className}`" :menuProps="{ attach: `.meeting-status-item-state-${className}` }" v-bind="{ ...attrs_input, loading }" @change="(state) => save({ state })" />
                </v-sheet>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import { attrs_input, EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES, initApplication, initMeetingSchedule, MEETING_SCHEDULE_STATES } from "@/assets/variables";

const scheduleStates = Object.values(MEETING_SCHEDULE_STATES);

export default {
    props: {
        value: { type: Object, default: initMeetingSchedule }, // schedule
        application: { type: Object, default: initApplication },
        schedulesAvailable: { type: Array, default: () => [] },
    },
    data: () => ({
        schedule: initMeetingSchedule(),

        loading: false,

        attrs_input,
        scheduleStates,
        className: Math.random().toString().slice(2),
    }),
    computed: {
        profileSrc() {
            return this.application?.resume?.profile?.url;
        },
        area() {
            let { address1 } = this.application?.resume?.personalInformation?.residence || {};
            return address1?.split?.(" ")?.slice(0, 2)?.join?.(" ");
        },
        education() {
            let { institutionType, attendingStatus } = this.application?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        infoItems() {
            return [this.application?.resume?.personalInformation?.phone, this.area, this.education];
        },
        scheduleDateItems() {
            return this.schedulesAvailable.map((value) => ({ value, text: dayjs(value).format("YYYY. MM. DD. HH:mm") }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.schedule = { ...this.value };
        },
        async save(form) {
            if (this.loading) return;
            this.loading = true;

            const { _id, _meeting, _company, _applicant, _recruitment, _application } = this.schedule;
            form = { _id, _meeting, _company, _applicant, _recruitment, _application, ...form };
            if (!_id) delete form._id;

            const { post, put } = api.v1.company.meetings.schedules;
            try {
                const { schedule } = await (_id ? put : post)(form);
                this.schedule = schedule;
            } finally {
                this.loading = false;
                this.$emit("search");
            }
        },
    },
};
</script>
